import styled from "styled-components";

export const ContainerMic = styled.div`
  width: 380px;
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-top: -16px;
  margin-bottom: 16px;
`;
